// extracted by mini-css-extract-plugin
module.exports = {"cardInfo":"teamCardInfo_cardInfo__2_tB0","teamName":"teamCardInfo_teamName__1uv_E","date":"teamCardInfo_date__uDO60"};